/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforbusiness2Inputs */

const en_goodforbusiness2 = /** @type {(inputs: Goodforbusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business`)
};

const de_goodforbusiness2 = /** @type {(inputs: Goodforbusiness2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschäftlich`)
};

/**
* | output |
* | --- |
* | "Business" |
*
* @param {Goodforbusiness2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforbusiness2 = /** @type {((inputs?: Goodforbusiness2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforbusiness2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforbusiness2(inputs)
	return de_goodforbusiness2(inputs)
});
export { goodforbusiness2 as "goodForBusiness" }